// AUTO-GENERATED by scripts/gen-build-info.js (npm prebuild hook). Do not edit by hand.
export const BUILD_INFO = {"commit":"dc774e508","time":"2026-11-03T14:14:01.682Z"} as const;
